import React from "react";
// import OnboardingActivity from "./OnboardingActivity";
// import OnboardingStats from "./OnboardingStats";
import CompanyInfoCard from "./CompanyBasicDetailsCard";
import OnboardingActivity from "./ToolsList";

const OnboardingTab = ({ companyData }) => {
    return (
        <div >

            
                <CompanyInfoCard companyData={companyData} />
               
           
            <div className="mt-5" >
                <OnboardingActivity companyData={companyData} />
            </div>

        </div>
    );
};

export default OnboardingTab;